import { Feedback } from "@phpcreation/frontend-components-react";
import React from "react";

type Props = {};

const AnonymousFeedback = (props: Props) => {
  return (
    <Feedback
      ticketUrl={process.env.NEXT_PUBLIC_TICKET_URL ?? ''}
      feedbackUrl={process.env.NEXT_PUBLIC_FEEDBACK_URL ?? ''}
      fqcn_bui={{ Bundle: 'ticketClient', Unit: 'feedback', Interface: 'form' }}
    />
  );
}

export default AnonymousFeedback;